export default [
  {
    path: '/zkbio-settings',
    name: 'zkbio-setting',
    meta: { requiresAuth: true },
    component: () => import('@/pages/zkbio-setting/index.vue')
  }
]
